var eventModes = ['internal', 'host', 'both'];
function isEventMode(value) {
    if (!value || typeof value !== 'string')
        return false;
    return eventModes.includes(value);
}
var analyticsMode = process.env.REACT_APP_ANALYTICS_MODE;
var leadsMode = process.env.REACT_APP_LEADS_MODE;
export var hearDigitsEventsConfig = {
    analytics: {
        enabled: process.env.REACT_APP_ANALYTICS_ENABLED === 'true',
        mode: isEventMode(analyticsMode) ? analyticsMode : 'internal',
    },
    leads: {
        enabled: process.env.REACT_APP_LEADS_ENABLED === 'true',
        mode: isEventMode(leadsMode) ? leadsMode : 'internal',
    },
};
